import * as React from 'react';
import { MathFunctions } from '../../global/functions/math';
import * as moment from 'moment';
import { IDropdownOption, DropdownSelect } from '../../global/components/inputs/dropdown';
import { Button } from '../../global/components/inputs/button';

interface IProps {
    startDate: moment.Moment;
    heading: string;
    buttonText: string;
    onClick: (value: moment.Moment) => void;
}

interface IState {
    currentDate: moment.Moment;
}



export class DateSelection extends React.Component<IProps, IState> {
    state: IState = {
        currentDate: this.props.startDate,
    }

    get months() {
        return [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December"
        ];
    }

    get years() {
        return MathFunctions.range(1999, 2090);
    }

    render() {
        const {
            heading,
            buttonText,
            startDate,
            onClick
        } = this.props;

        const { currentDate } = this.state;

        return (
            <div className="liturgical-calendar-selection">
                <h3 className="select-header">Select Calendar</h3>
                <div className="select-period">
                    <label className="month-text">
                        <span>*</span> Month:
                    </label>
                    <DropdownSelect
                        selectedId={startDate.month().toString()}
                        onDropdownSelect={this.setCurrentDateMonth}
                        values={this.months.map((x, index) => {
                            return Object.freeze({
                                display: x,
                                value: index,
                                id: index.toString()
                            } as IDropdownOption)
                        })}
                    />
                </div>
                <div className="select-period">
                    <label className="year-text">
                        <span>*</span> Year:
                    </label>
                    <DropdownSelect
                        selectedId={startDate.year().toString()}
                        onDropdownSelect={this.setCurrentDateYear}
                        values={this.years.map((x, index) => {
                            return Object.freeze({
                                display: x,
                                value: x,
                                id: x
                            } as IDropdownOption)
                        })}
                    />
                </div>
                <Button label={buttonText} id={"btn-show-calendar"} onClick={() => onClick(currentDate)} />
            </div>
        );
    }

    setCurrentDateYear = (value: string) => {
        this.setState(prevState => {
            prevState.currentDate.year(parseInt(value));
            return prevState
        })
    }

    setCurrentDateMonth = (value: string) => {
        this.setState(prevState => {
            prevState.currentDate.month(parseInt(value));
            return prevState
        })
    }
}